import "./styles.scss";
import { useIntl } from "react-intl";

const Loading = () => {
  const intl = useIntl();

  return (
    <div className="contract-details-sidebar__loading">
      <div className="spinnerInfoBox display-flex justify-content-center align-items-center">
        <div className="spinner" />
        <div className="spinnerText">{intl.formatMessage({ id: "intl-msg:contractDetailsSidebar.loading" })}</div>
      </div>
    </div>
  )
};

export default Loading;
